// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"v6AHt68ZFXb37Sn9riOX"};